import { PLACEMENT_ROW_ORDER } from "../../constants/placements.constants"
import { IPlacementDataTable } from "../../types/placement"
import { placementsEnum } from "../../types/types"

const UNKNOWN_PLACEMENT_ORDER = PLACEMENT_ROW_ORDER.length

const orderIndex = (placement: string): number => {
  const index = PLACEMENT_ROW_ORDER.indexOf(placement as placementsEnum)
  return index === -1 ? UNKNOWN_PLACEMENT_ORDER : index
}

export const sortPlacementRows = (rows: IPlacementDataTable[]): IPlacementDataTable[] =>
  [...rows].sort((left, right) => orderIndex(left.placement) - orderIndex(right.placement))
